// const pinpadUrl = 'https://pinpadmock.free.beeceptor.com/start-transaction'
const pinpadUrl = '/totem/venda.php'

// apagar abaixo depois de trocar tudo
const pinpadAuth = "123"
const version = "1.0.0"

export { pinpadUrl, pinpadAuth, version }
